<template>
  <div class="container">
    <div v-html="data"></div>
  </div>
</template>
<script>
import http from "@/services/http.js";
export default {
  name: "StaticPage",
  props: ["slug"],

  data() {
    return {
      data: "",
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      http
        .get("/static-page/" + this.slug)
        .then((response) => {
          this.data = response.data.data.content;

          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>